/* Sheswaisted cart upsell: theme-hosted, Intelligems activated on mobile and desktop. */
(() => {
  if (window.swCartUpsell) return;
  const activationClass = "sw-cart-upsell-test-new";
  // The theme can load these assets safely for every visitor. Only the Intelligems
  // New Upsell group calls activate(); everyone else keeps their native cart.
  window.swCartUpsell = {
    version: "1.1.0",
    activate() {
      document.documentElement.classList.add(activationClass);
      refresh();
    }
  };
  const drawerSelector = "#cart-drawer";
  let refreshId = 0, busy = false, rendering = false, activeProductId = null;
  const rootUrl = (window.Shopify?.routes?.root || "/").replace(/\/?$/, "/");
  const emit = (name, data = {}) => {
    const detail = { ...data, component: "sw_cart_upsell_v1" };
    document.dispatchEvent(new CustomEvent("sw:cart-upsell:" + name, { detail }));
    const eventName = "sw_cart_upsell_" + name;
    window.dataLayer?.push({ event: eventName, ...detail });
    // Available to Shopify custom pixels that explicitly subscribe to this event.
    window.Shopify?.analytics?.publish?.(eventName, detail);
    if (name === "add_success") {
      trackIntelligems("sw_cart_upsell_success", { ...detail, upsell_style: "new" });
    } else if (name === "size_select") {
      trackIntelligems("sw_cart_upsell_size_select", { ...detail, upsell_style: "new" });
    }
  };
  function trackIntelligems(event, properties) {
    try {
      window.igEvents = window.igEvents || [];
      window.igEvents.push({ event, properties });
    } catch (_) {}
  }
  // The legacy carousel sometimes opens a quick-buy drawer. Impact moves this
  // drawer under document.body while open, so its final variant:add no longer
  // has a #cart-drawer ancestor. Remember which drawer was opened from the
  // carousel rather than counting all quick-buy additions throughout the site.
  document.addEventListener("click", (event) => {
    if (document.documentElement.classList.contains(activationClass)) return;
    const button = event.target.closest?.("#cart-drawer .cart-drawer__recommendations .horizontal-product__cta button");
    if (!button) return;
    const quickBuyId = button.getAttribute("aria-controls");
    const quickBuy = quickBuyId && document.getElementById(quickBuyId);
    if (quickBuy?.matches("quick-buy-drawer")) {
      quickBuy.dataset.swCartUpsellOriginal = "true";
    }
  }, true);
  document.addEventListener("dialog:after-hide", (event) => {
    const quickBuy = event.target.closest?.("quick-buy-drawer[data-sw-cart-upsell-original]");
    if (quickBuy) delete quickBuy.dataset.swCartUpsellOriginal;
  }, true);
  // Impact emits variant:add only after Shopify confirms the add.
  document.addEventListener("variant:add", (event) => {
    if (document.documentElement.classList.contains(activationClass)) return;
    const source = event.target;
    const inCarousel = !!source?.closest?.("#cart-drawer .cart-drawer__recommendations");
    const openedFromCarousel = source?.closest?.('quick-buy-drawer[data-sw-cart-upsell-original="true"]');
    if (!inCarousel && !openedFromCarousel) return;
    if (openedFromCarousel) delete openedFromCarousel.dataset.swCartUpsellOriginal;
    const items = event.detail?.items;
    if (!Array.isArray(items) || !items.length) return;
    for (const item of items) {
      trackIntelligems("sw_cart_upsell_success", {
        upsell_style: "original",
        product_id: item.product_id,
        variant_id: item.id,
        quantity: item.quantity || 1
      });
    }
  }, true);
  const escapeHtml = value => String(value ?? "").replace(/[&<>"']/g, char =>
    ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[char]));
  const getJson = async path => {
    const res = await fetch(rootUrl + path, { credentials: "same-origin" });
    if (!res.ok) throw new Error("Request failed: " + res.status);
    return res.json();
  };
  const usable = (product, cart) => product && product.available && Array.isArray(product.variants) &&
    product.variants.some(v => v.available) && !cart.items.some(i => String(i.product_id) === String(product.id));
  async function recommendations(cart) {
    const items = (cart.items || []).slice(0, 3);
    if (!items.length) return [];
    const fetchRecs = async (productId, intent) => {
      try {
        const path = "recommendations/products.json?product_id=" + encodeURIComponent(productId) + "&limit=10&intent=" + intent;
        const data = await getJson(path);
        return data.products || [];
      } catch (_) { return []; }
    };
    const eligibleUnique = products => {
      const seen = new Set();
      return products.filter(product => {
        if (!usable(product, cart) || seen.has(String(product.id))) return false;
        seen.add(String(product.id));
        return true;
      });
    };
    // Prefer manually curated Search & Discovery complementary recommendations.
    // If those products are already in the cart, try another cart item.
    for (const item of items) {
      const products = eligibleUnique(await fetchRecs(item.product_id, "complementary"));
      if (products.length) return products;
    }
    // Next use the merchant-curated Trending products as a reliable fallback.
    const drawer = document.querySelector(drawerSelector);
    let handles = [];
    try {
      handles = JSON.parse(drawer?.querySelector("[data-sw-cart-upsell]")?.dataset.swFallbackHandles || "[]");
    } catch (_) {}
    const fallback = [];
    for (const handle of handles.slice(0, 10)) {
      try {
        const product = await getJson("products/" + encodeURIComponent(handle) + ".js");
        fallback.push(product);
      } catch (_) {}
    }
    const curated = eligibleUnique(fallback);
    if (curated.length) return curated;
    // Only use Shopify's algorithmic related products as the last fallback.
    for (const item of items) {
      const products = eligibleUnique(await fetchRecs(item.product_id, "related"));
      if (products.length) return products;
    }
    return [];
  }
  function optionName(option) { return typeof option === "string" ? option : String(option?.name || option?.title || "Option"); }
  function isSize(name) { return /size|band|cup/i.test(optionName(name)); }
  function isColor(name) { return /colo(u)?r/i.test(optionName(name)); }
  function getOptionValues(product, pos) {
    // Show all actual variant values, including disabled sold-out options.
    return [...new Set(product.variants.map(v => v["option" + (pos+1)]).filter(Boolean))];
  }
  function optionHasAvailableVariant(product, choices, pos, value) {
    // Apply already-chosen earlier options. Ignore later options so shoppers
    // can switch colors without first clearing an incompatible size.
    return product.variants.some(v => v.available &&
      v["option" + (pos+1)] === value &&
      choices.every((selected, index) =>
        index >= pos || !selected || v["option" + (index+1)] === selected));
  }
  function matchingVariant(product, choices) {
    return product.variants.find(v => v.available && choices.every((val,i) => val !== "" && v["option"+(i+1)] === val));
  }
  function imageFor(product, choices) {
    const colorAt = product.options.findIndex(isColor);
    const color = colorAt < 0 ? "" : choices[colorAt];
    const variant = product.variants.find(v => v.available && (colorAt < 0 || v["option"+(colorAt+1)] === color));
    const src = variant?.featured_image?.src || product.featured_image || product.images?.[0];
    return typeof src === "string" ? src : src?.src;
  }
  function money(cents) {
    const format = window.Shopify?.currency?.active || "USD";
    return new Intl.NumberFormat(undefined, {style:"currency",currency:format}).format(cents/100);
  }
  function build(product, cart, mount) {
    if (!mount.isConnected) return;
    const names = product.options.map(optionName);
    const cartSource = cart.items?.[0];
    const choices = names.map((label,i) => {
      if (isColor(label)) {
        const colorInCart = cartSource?.options_with_values?.find(o => isColor(o.name))?.value;
        const colors = getOptionValues(product, i);
        const inStock = colors.filter(value => product.variants.some(v =>
          v.available && v["option" + (i+1)] === value));
        return inStock.includes(colorInCart) ? colorInCart : inStock[0] || "";
      }
      // Never silently assign a size, including where the cart uses the same name.
      return "";
    });
    const allDefault = names.length === 1 && names[0] === "Title";
    if (allDefault) choices[0] = "Default Title";
    const button = mount.querySelector("[data-sw-rec-row]");
    if (!button) return;
    let failed = false;
    const paint = () => {
      const image = imageFor(product, choices);
      const selects = allDefault ? "" : names.map((name,i) => {
        const values = getOptionValues(product,i);
        const selected = choices[i];
        return '<label class="sw-cart-upsell__select"><span class="sr-only">'+escapeHtml(name)+'</span><select data-sw-option="'+i+'" aria-label="'+escapeHtml(name)+'" '+(failed&&!selected?'aria-invalid="true"':'')+'><option value="">'+escapeHtml(name)+'</option>'+values.map(value => {
          const available = optionHasAvailableVariant(product, choices, i, value);
          return '<option value="'+escapeHtml(value)+'" '+(selected===value?'selected':'')+
            (available?'':' disabled aria-disabled="true"')+'>'+
            escapeHtml(value)+(available?'':' — Sold out')+'</option>';
        }).join("")+'</select></label>';
      }).join("");
      button.innerHTML =
        '<img class="sw-cart-upsell__image" src="'+escapeHtml(image||"")+'" alt="'+escapeHtml(product.title)+'" loading="lazy">'+
        '<div class="sw-cart-upsell__detail"><a class="sw-cart-upsell__title" href="'+escapeHtml(product.url||("#"))+'">'+escapeHtml(product.title)+'</a>'+
        '<p class="sw-cart-upsell__price">'+money(product.price)+'</p>'+
        '<div class="sw-cart-upsell__options">'+selects+'</div></div>'+
        '<button type="button" class="sw-cart-upsell__add" data-sw-add>+ Add</button>';
    };
    paint();
    const feedback = mount.querySelector("[data-sw-rec-feedback]");
    const showError = msg => { feedback.textContent = msg; feedback.hidden = false; };
    mount.addEventListener("change", event => {
      const select = event.target.closest("select[data-sw-option]");
      if (!select) return;
      const selectedIndex = Number(select.dataset.swOption);
      // Guard against forged/programmatic selection of disabled values.
      if (select.value && !optionHasAvailableVariant(product, choices, selectedIndex, select.value)) {
        choices[selectedIndex] = "";
        failed = true;
        paint();
        showError("That option is sold out. Please choose an available option.");
        return;
      }
      choices[selectedIndex] = select.value;
      // Changing a color/band may invalidate later selections: clear them.
      for (let i = selectedIndex + 1; i < choices.length; i++) {
        if (choices[i] && !optionHasAvailableVariant(product, choices, i, choices[i])) choices[i] = "";
      }
      failed = false;
      feedback.hidden = true; paint();
      const optionDetail = {
        product_id: product.id,
        option_name: names[selectedIndex],
        option_value: select.value
      };
      emit("variant_select", optionDetail);
      if (select.value && isSize(names[selectedIndex])) {
        emit("size_select", optionDetail);
      }
    });
    mount.addEventListener("click", async event => {
      const btn = event.target.closest("button[data-sw-add]");
      if (!btn || busy) return;
      const missing = choices.findIndex((v,i) => !v && !allDefault);
      emit("add_click", {
        product_id: product.id,
        options_complete: missing < 0,
        selected_options: names.reduce((acc, name, index) => {
          if (choices[index]) acc[name.toLowerCase().replace(/[^a-z0-9]+/g, "_")] = choices[index];
          return acc;
        }, {})
      });
      if (missing >= 0) {
        failed=true;paint();showError("Please choose your "+names[missing].toLowerCase()+".");
        emit("variant_required",{product_id:product.id,option_name:names[missing]});
        button.querySelector('select[data-sw-option="'+missing+'"]')?.focus();
        return;
      }
      const variant = matchingVariant(product,choices);
      if (!variant) { failed=true;paint();showError("That combination is unavailable. Please choose another.");return; }
      busy=true;btn.disabled=true;btn.textContent="Adding…";
      emit("add_attempt",{product_id:product.id,variant_id:variant.id});
      try {
        const sections=[];
        document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections",{bubbles:true,detail:{sections}}));
        const resp=await fetch(rootUrl+"cart/add.js",{
          method:"POST",headers:{"Content-Type":"application/json","X-Requested-With":"XMLHttpRequest"},
          credentials:"same-origin",body:JSON.stringify({items:[{id:variant.id,quantity:1}],sections,sections_url:location.pathname})
        });
        const result=await resp.json();
        if (!resp.ok) throw new Error(result.description || "Could not add this item.");
        const next=await getJson("cart.js");
        next.sections=result.sections || {};
        emit("add_success",{product_id:product.id,variant_id:variant.id,price:variant.price});
        if (sections.length && next.sections[sections.find(s=>next.sections[s])]) {
          document.documentElement.dispatchEvent(new CustomEvent("cart:change",{bubbles:true,detail:{baseEvent:"variant:add",cart:next}}));
        } else {
          document.dispatchEvent(new CustomEvent("cart:refresh"));
        }
      } catch(err) {
        showError(err.message || "Could not add item. Please try again.");
        emit("add_error",{product_id:product.id,message:String(err.message || err)});
        btn.disabled=false;btn.textContent="+ Add";
      } finally {busy=false;}
    });
    mount.hidden=false;
    drawerState(mount,true);
    emit("impression",{product_id:product.id,source:"shopify_recommendations"});
  }
  function drawerState(mount, visible) {
    const drawer=mount.closest(drawerSelector);
    drawer?.classList.toggle("sw-cart-upsell-ready",visible);
  }
  async function refresh() {
    if (!document.documentElement.classList.contains(activationClass) || rendering || busy) return;
    const mount=document.querySelector(drawerSelector+" [data-sw-cart-upsell]");
    if (!mount || mount.dataset.swInitialized) return;
    mount.dataset.swInitialized="loading";
    const id=++refreshId;
    rendering=true;
    try {
      const cart=await getJson("cart.js");
      const candidates=await recommendations(cart);
      if (id!==refreshId || !mount.isConnected) return;
      const product=candidates[0];
      if (!product) { mount.hidden=true;drawerState(mount,false);return; }
      mount.dataset.swInitialized="ready";
      activeProductId=product.id;
      build(product,cart,mount);
    }catch(e) {
      mount.hidden=true;drawerState(mount,false);
    }finally{rendering=false;}
  }
  const observer=new MutationObserver(() => {
    if (!document.documentElement.classList.contains(activationClass)) return;
    const mount=document.querySelector(drawerSelector+" [data-sw-cart-upsell]");
    if (mount && !mount.dataset.swInitialized) refresh();
  });
  function start(){
    const drawer=document.querySelector(drawerSelector);
    if(!drawer)return;
    observer.observe(drawer,{childList:true,subtree:true});
    refresh();
    document.addEventListener("cart:change",()=>setTimeout(refresh,150));
    document.addEventListener("cart:refresh",()=>setTimeout(refresh,250));
  }
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",start,{once:true});else start();
})();
